export default function TermsOfService() {
  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 font-ui text-[#1A362D] leading-relaxed">
      <p className="label-eyebrow text-[#C05C45]">Informativa</p>
      <h1 className="mt-2 font-display text-4xl sm:text-5xl tracking-tight">Termini di Servizio</h1>
      <p className="mt-6 text-[#5C6B64]">
        Ultimo aggiornamento:{" "}
        {new Date().toLocaleDateString("it-IT", { year: "numeric", month: "long" })}
      </p>

      <section className="mt-10 space-y-4">
        <h2 className="font-display text-2xl mt-8">1. Accettazione dei termini</h2>
        <p>
          L'utilizzo del sito <strong>Per manina</strong> (di seguito "il Servizio") implica l'accettazione
          integrale dei presenti Termini di Servizio. Se non condividi anche solo una delle clausole sotto
          riportate, ti chiediamo di non utilizzare il Servizio.
        </p>

        <h2 className="font-display text-2xl mt-8">2. Descrizione del Servizio</h2>
        <p>
          Per manina è una community indipendente che permette ai genitori italiani di cercare scuole
          dell'infanzia, leggere e pubblicare esperienze, suggerire scuole mancanti o correzioni. Le
          informazioni sulle scuole derivano in parte da fonti pubbliche (es. anagrafe scolastica MIUR) e in
          parte da contributi della community. Il Servizio è offerto gratuitamente "così com'è", senza
          garanzie di completezza o aggiornamento costante dei dati.
        </p>

        <h2 className="font-display text-2xl mt-8">3. Account e registrazione</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            La registrazione avviene esclusivamente tramite autenticazione Google. Non vengono richieste né
            memorizzate password.
          </li>
          <li>
            Per registrarsi è necessario avere almeno <strong>16 anni</strong> (in conformità all'art. 8
            GDPR). I genitori sono responsabili di garantire questo requisito.
          </li>
          <li>
            Ogni utente è responsabile della custodia del proprio account Google e di qualsiasi attività
            effettuata tramite esso.
          </li>
          <li>
            L'utente può eliminare il proprio account in qualunque momento dall'Area Personale: tutte le
            esperienze associate verranno rimosse.
          </li>
        </ul>

        <h2 className="font-display text-2xl mt-8">4. Esperienze — regole di condotta</h2>
        <p>Pubblicando una esperienza, l'utente dichiara e garantisce che:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            La esperienza è basata su <strong>esperienza personale diretta</strong> con la scuola
            raccontata (in qualità di genitore, tutore o familiare di un alunno).
          </li>
          <li>
            Il contenuto è <strong>veritiero</strong>, non contiene affermazioni false o diffamatorie e non
            viola la dignità di persone identificabili.
          </li>
          <li>
            Non vengono pubblicati dati personali di terzi (es. nomi e cognomi di insegnanti, bambini,
            personale ATA, dirigenti) né immagini di minori.
          </li>
          <li>
            Il contenuto è proprio originale (l'utente detiene tutti i diritti) e non viola copyright né
            marchi.
          </li>
          <li>
            La esperienza non è scritta per conto di terzi, dietro compenso o con finalità promozionali o
            denigratorie organizzate.
          </li>
        </ul>
        <p>
          Concedendo i propri contenuti, l'utente accorda a Per manina una licenza non esclusiva, gratuita e
          mondiale per pubblicarli, archiviarli e indicizzarli nel motore di ricerca del sito.
        </p>

        <h2 className="font-display text-2xl mt-8">5. Contenuti vietati</h2>
        <p>È espressamente vietato pubblicare contenuti che:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Siano illeciti, diffamatori, offensivi, volgari, razzisti, sessisti o discriminatori;</li>
          <li>Contengano insulti diretti a singole persone fisiche identificabili;</li>
          <li>Promuovano prodotti o servizi terzi (spam pubblicitario);</li>
          <li>Contengano informazioni sanitarie sensibili relative a minori;</li>
          <li>Violino diritti di proprietà intellettuale altrui.</li>
        </ul>

        <h2 className="font-display text-2xl mt-8">6. Moderazione</h2>
        <p>
          Per manina si riserva il diritto, ma <strong>non l'obbligo</strong>, di moderare i contenuti
          pubblicati. Esperienze che violano i presenti Termini potranno essere rimosse senza preavviso;
          l'account dell'utente potrà essere sospeso in caso di violazioni reiterate o gravi. La rimozione
          non comporta alcun obbligo di risarcimento.
        </p>
        <p>
          Le scuole e gli enti rappresentati hanno diritto di replica pubblica alle esperienze e possono
          segnalare contenuti illegittimi scrivendo all'indirizzo di contatto indicato in fondo. Le
          segnalazioni vengono valutate normalmente entro 7 giorni lavorativi.
        </p>

        <h2 className="font-display text-2xl mt-8">7. Esonero di responsabilità</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            Le esperienze e i suggerimenti pubblicati esprimono <strong>opinioni personali</strong> degli
            utenti, di cui Per manina non garantisce veridicità o accuratezza.
          </li>
          <li>
            I dati sulle scuole (indirizzi, contatti, CAP) derivano da fonti pubbliche e contributi
            community: possono contenere errori, imprecisioni o non essere aggiornati. Per qualsiasi
            decisione importante (es. iscrizione, contatto diretto), invitiamo a verificare le informazioni
            tramite i canali ufficiali della scuola.
          </li>
          <li>
            Per manina non è in alcun modo affiliata né rappresentativa delle scuole presenti nel database.
          </li>
          <li>
            Il Servizio è fornito "as is": non garantiamo continuità di funzionamento né assenza di errori
            tecnici.
          </li>
        </ul>

        <h2 className="font-display text-2xl mt-8">8. Proprietà intellettuale</h2>
        <p>
          Il nome "Per manina", il logo, il design del sito e il codice sorgente sono protetti da diritto
          d'autore. È vietata la riproduzione, anche parziale, senza esplicita autorizzazione scritta. La
          consultazione dei dati delle scuole è gratuita per uso personale e non commerciale; lo scraping
          automatico massivo e la rivendita dei dati sono vietati.
        </p>

        <h2 className="font-display text-2xl mt-8">9. Privacy, cookie e pubblicità</h2>
        <p>
          Il trattamento dei dati personali è disciplinato dalla nostra{" "}
          <a href="/info/privacy" className="underline text-[#C05C45]">
            Privacy Policy
          </a>{" "}
          e dalla{" "}
          <a href="/info/cookie" className="underline text-[#C05C45]">
            Cookie Policy
          </a>
          . Utilizziamo cookie tecnici essenziali per la sessione di login e, solo previo tuo consenso espresso tramite il banner cookie,
          cookie analitici anonimi e cookie di profilazione pubblicitaria (Google AdSense ed eventuali vendor del framework IAB TCF 2.2).
          Puoi gestire o revocare le tue preferenze cookie in qualsiasi momento.
        </p>

        <h2 className="font-display text-2xl mt-8">10. Modifiche al Servizio e ai Termini</h2>
        <p>
          Per manina può modificare in qualsiasi momento il presente documento o le caratteristiche del
          Servizio. Le modifiche sostanziali verranno comunicate aggiornando la data in alto e, ove
          opportuno, tramite avviso in homepage. La prosecuzione nell'uso del Servizio dopo la pubblicazione
          delle modifiche implica accettazione.
        </p>

        <h2 className="font-display text-2xl mt-8">11. Legge applicabile e foro</h2>
        <p>
          I presenti Termini sono regolati dalla legge italiana. Per qualsiasi controversia derivante
          dall'utilizzo del Servizio è competente in via esclusiva il <strong>Foro di Milano</strong>,
          salva l'eventuale competenza inderogabile prevista dal Codice del Consumo per gli utenti
          qualificabili come consumatori.
        </p>

        <h2 className="font-display text-2xl mt-8">12. Contatti</h2>
        <p>
          Per richieste, segnalazioni o esercizio dei diritti GDPR è possibile scrivere all'indirizzo email
          indicato all'interno della{" "}
          <a href="/info/privacy" className="underline text-[#C05C45]">
            Privacy Policy
          </a>
          .
        </p>
      </section>
    </article>
  );
}
